let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1KIaN")).then(() => parcelRequire('PwsJ9'));